// extracted by mini-css-extract-plugin
module.exports = {"selectedCounter":"SelectAll_selectedCounter__kYSrW","selectAllLabel":"SelectAll_selectAllLabel__1zafo"};